import { useEffect, useState } from "react";

/**
 * Bump-only counter that changes whenever the cached staff profile
 * (localStorage "user") is refreshed — see localStorage/index.js `setUser`
 * (fires "user-profile-updated") and utils/refreshUserProfile.js (the actual
 * server re-fetch, triggered on navigation by scenes/layout/index.jsx).
 *
 * Most permission checks in this app (hasPageAccess/getVisibleTabs call
 * sites) already read user()/localStorage fresh on every render — they just
 * have no reason to ever RE-render once mounted. Call this hook (its return
 * value doesn't matter, it's only there to become a new value and force a
 * re-render) anywhere a permission check needs to reflect a Role edit made
 * while the user is already logged in, without requiring a full re-login.
 */
export function useUserRefreshTick() {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const bump = () => setTick((t) => t + 1);
    window.addEventListener("user-profile-updated", bump);
    window.addEventListener("storage", bump); // other-tab login/role changes
    return () => {
      window.removeEventListener("user-profile-updated", bump);
      window.removeEventListener("storage", bump);
    };
  }, []);
  return tick;
}
